

(function($, window ){

	var infiniteScrollerRun = true;
	var getMorePosts = function( ) {
        var infiniteScroller = window.infiniteScroller;
		var data = {
			action    : 'mu_infinite_load_more_posts',
			post_type : infiniteScroller.post_type,
			page      : infiniteScroller.page,
			taxonomy  : infiniteScroller.taxonomy,
			term      : infiniteScroller.term
		};
		
		if ( data.page === 'last' ) {
			return; // no more posts!
		}
		
		
		if ( data.page === 0 ||  data.page === 1 ) {
			data.page = 2;
		} 
		
		if ( true === infiniteScroller.is_search ) {
			data.post_type = 'search';
		}
		// console.log( data );
		infiniteScrollerRun = false;
		$('.mu-infinite-loader').addClass( 'loading' );
		$.post( site_data.ajax_url, data, function( response ) {
			if ( ! response.content ) {
				infiniteScroller = false;
				$( window ).off( 'scroll', infiniteScroll );
				$('.mu-infinite-loader').remove();
				infiniteScrollerRun = false;
				return;
			}
			setTimeout(function(){
				$('.mu-infinite-loader').removeClass( 'loading' );
				$( '#posts-wrap' ).append( response.content );
			
				infiniteScroller.page = response.next;
				
				if ( response.next === 'last' ) {
					infiniteScroller = false;
					$( window ).off( 'scroll', infiniteScroll );
					$('.mu-infinite-loader').remove();
					infiniteScrollerRun = false;
					return;
				}	
				infiniteScrollerRun = true;
			}, 1000);
			
		}, "JSON");
		
	};
	
	var infiniteScroll = function ( e ){
		//console.log( 'scrolling' );
		if ( ( e.type === 'scroll'  || e.type === 'click' ) && infiniteScrollerRun ) {
			
			
			var elementTop = $('.mu-infinite-loader').offset().top;
			var elementBottom = elementTop + $('.mu-infinite-loader').outerHeight();
			var viewportTop = $(window).scrollTop();
			var viewportBottom = viewportTop + $(window).height();
			
			// console.log( elementBottom, viewportTop, elementTop, viewportBottom );
			if ( elementBottom > viewportTop && elementTop < viewportBottom ) {
				// it's visible.
				getMorePosts();
			} 
		}
	};
	
	$( document ).ready(function(){
        
		if ( typeof window.infiniteScroller !== 'undefined' ) {
			// let's play this game.
			$( window ).on( 'scroll', infiniteScroll );
		}
	});
	
})( jQuery, window );